<template>
  <div class="courses-containers main-view">
    <div style="min-height: 500px;" class="mt-20">
      <div class="flex justify-center" v-if="listOrder.length === 0">
        <el-empty description="Giỏ hàng trống" :image-size="200">
          <button
            style="width:300px"
            @click="$router.push('Courses')"
            class="add-courses"
          >
            Buy Now
          </button>
        </el-empty>
      </div>
      <el-row v-else>
        <el-col :xs="24" :sm="20" :md="20" :lg="20" :xl="20">
          <div>
            <div class="list-order">
              <div class="flex justify-space-between align-center">
                <h4 class="fw-600">Giỏ hàng của bạn</h4>
                <!-- <i style="font-weight: 800;" class="el-icon-arrow-down"></i> -->
              </div>
            </div>
            <div v-for="(item, index) in listOrder" :key="index" class="mt-20">
              <div class="flex align-center">
                <el-checkbox
                  class="checkbox-carts"
                  style="margin-right: 20px;"
                  v-model="item.checked"
                  @change="handleAdd(item)"
                ></el-checkbox>
                <CardOrder :object-data="item" />
              </div>
            </div>
            <div style="margin-top: 30px;" class="flex justify-center">
              <button
                style="width:300px"
                @click="handleAddCard"
                class="add-courses"
              >
                Buy Now
              </button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import ImageTeacher from "@/assets/img/img_edu/Video.png";
import QrCode from "@/assets/img/img_edu/QrCode.png";
import UserIcon from "@/assets/img/svg_edu/UserIcon.svg";
import HatIcon from "@/assets/img/svg_edu/HatIcon.svg";
import CheckBoxIcon from "@/assets/img/svg_edu/CheckBox.svg";
import { getOrder, getCart } from "../../../utils/orders";
import CardOrder from "@/views/components/card/CardOrder.vue";
import CoursesPurchaseResource from "@/views/api/course-purchase.js";
import { formatNumber } from "@/utils/formatData";

export default {
  name: "detai-courses",
  props: {},
  components: {
    CardOrder
  },
  created() {
    this.onGetTransaction();
  },
  data() {
    return {
      dataOrder: [],
      checked: false,
      dataPayment: {},
      isLoading: false,
      listOrder: getCart() || [],
      value: "",
      img: {
        ImageTeacher,
        QrCode
      },
      icons: {
        HatIcon,
        UserIcon,
        CheckBoxIcon
      }
    };
  },
  watch: {},
  methods: {
    handleAdd(item) {
      console.log(item);
      if (item.checked) {
        this.dataOrder.push(item);
      } else {
        this.dataOrder = this.dataOrder.filter(
          i => i.course_id !== item.course_id
        );
      }
      console.log("this.dataOrder____", this.dataOrder);
    },
    async handleAddCard() {
      if (this.dataOrder.length === 0) {
        this.$message.warning("Please select the course that requires payment.");
        return;
      }
      console.log("this.dataOrder____", this.dataOrder);
      setOrder(this.dataOrder);
      return this.$router.push("/Orders");
    },
    onGetTransaction() {
      const body = { page: 1, limit: 10, status: 1 };
      CoursesPurchaseResource.ListTracsaction(body).then(res => {
        console.log("ListTracsaction-____", res);
      });
    },
    formatNumber
  }
};
</script>
<style>
.checkbox-carts .el-checkbox__input .el-checkbox__inner {
  width: 23px;
  height: 23px;
  border-radius: 6px;
}
.checkbox-carts .el-checkbox__input .el-checkbox__inner::after {
  box-sizing: content-box;
  content: "";
  border: 2px solid #fff;
  border-left: 0;
  border-top: 0;
  height: 7px;
  left: 7px;
  position: absolute;
  top: 5px;
}
</style>
<style scoped>
.add-courses {
  border-radius: 32px;
  background-color: #035ae0;
  color: #ffff;
  width: 100%;
  min-height: 48px;
  font-weight: 600;
  font-size: 16px;
  margin: 20px 0;
}
.add-courses:hover {
  background-color: #035ae0;
  color: #ffff;
}
.info-container {
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0px 20px 40px 0px #0000000f;
  background: #fff;
}
.img-teacher {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.title {
  font-size: 29px;
  font-weight: 700;
  line-height: 52.8px;
  text-align: left;
  margin: 10px 0;
  padding: 0;
}
.courses-containers {
  min-width: 1100px !important;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-right: 15px;
  padding-left: 15px;
}
.main-view {
  padding-top: 100px;
}
</style>
